<script setup lang="ts">
/** Singapura — Active-Exempt-unaudited AGM 문서 패키지(1.a~1.e). Verification/Active-Decl 과 동일 크롬. */
import { ref } from 'vue';
import AgmReslnDoc from './AgmReslnDoc.vue';
import AgmNoticeDoc from './AgmNoticeDoc.vue';
import AgmAgreementDoc from './AgmAgreementDoc.vue';
import AgmMinutesDoc from './AgmMinutesDoc.vue';
import AgmAttendanceDoc from './AgmAttendanceDoc.vue';

const ZOOM_MIN = 100, ZOOM_MAX = 175, ZOOM_STEP = 25;
const docZoom = ref(100);
function setZoom(n: number) { docZoom.value = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(n / ZOOM_STEP) * ZOOM_STEP)); }
function gatherLocalState() { return {}; }
function restoreLocalState() { /* 상태는 fill 값에 있음 */ }
defineExpose({ gatherLocalState, restoreLocalState });

const DOCS = [
  { label: '1.a AGM-resln.docx', comp: AgmReslnDoc },
  { label: '1.b AGM-notice.docx', comp: AgmNoticeDoc },
  { label: '1.c AGM-agreemt to shorter notice.docx', comp: AgmAgreementDoc },
  { label: '1.d AGM-min.docx', comp: AgmMinutesDoc },
  { label: '1.e AGM-att sheet.docx', comp: AgmAttendanceDoc },
];
</script>

<template>
  <div class="ver-pkg">
    <div class="zoom-bar">
      <div class="doc-zoom">
        <button type="button" class="doc-zoom-btn" :disabled="docZoom <= ZOOM_MIN" @click="setZoom(docZoom - ZOOM_STEP)">A−</button>
        <button type="button" class="doc-zoom-pct" @click="setZoom(100)">{{ docZoom }}%</button>
        <button type="button" class="doc-zoom-btn" :disabled="docZoom >= ZOOM_MAX" @click="setZoom(docZoom + ZOOM_STEP)">A+</button>
      </div>
    </div>
    <div class="paper-zoom" :style="{ zoom: docZoom / 100 }">
      <div class="stage-head"><span class="stage-badge">AGM</span><span class="stage-t">Active-Exempt-unaudited — AGM Documents</span></div>
      <template v-for="(d, i) in DOCS" :key="i">
        <div class="pkg-doclabel"><span class="ic">📄</span><span class="nm">{{ d.label }}</span><span class="no">Doc {{ i + 1 }} / {{ DOCS.length }}</span></div>
        <div class="simple-frame"><component :is="d.comp" /></div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.ver-pkg { color: #111; }
.zoom-bar { display: flex; justify-content: flex-end; width: 794px; max-width: 100%; margin: 0 auto 14px; }
.doc-zoom { display: inline-flex; align-items: center; gap: 2px; background: #f2f4f6; border-radius: 10px; padding: 2px; }
.doc-zoom-btn, .doc-zoom-pct { border: none; background: transparent; cursor: pointer; font-weight: 800; color: #4b5563; border-radius: 8px; height: 32px; }
.doc-zoom-btn { min-width: 36px; font-size: 15px; } .doc-zoom-btn:disabled { opacity: 0.35; cursor: default; }
.doc-zoom-pct { min-width: 52px; font-size: 12px; color: #3182f6; }
.paper-zoom { width: 794px; max-width: 100%; margin: 0 auto; }
.stage-head { display: flex; align-items: center; gap: 12px; margin: 0 0 16px; padding: 4px 2px 14px; border-bottom: 1px solid #eef1f6; }
.stage-badge { flex: none; background: #1b64da; color: #fff; font-weight: 800; font-size: 12.5px; padding: 5px 12px; border-radius: 999px; }
.stage-t { font-weight: 800; font-size: 15px; color: #1f2d4d; }
.pkg-doclabel { display: flex; align-items: center; gap: 8px; padding: 18px 4px 12px; }
.pkg-doclabel .ic { font-size: 14px; } .pkg-doclabel .nm { font-size: 12.5px; font-weight: 800; color: #42506a; }
.pkg-doclabel .no { margin-left: auto; font-size: 10.5px; font-weight: 800; color: #9aa6bd; }
.simple-frame { width: 100%; background: #fff; border: 1px solid #e2e5ea; box-shadow: 0 4px 20px rgba(20,30,60,0.09); padding: 32px; box-sizing: border-box; overflow: hidden; font-size: 12px; margin-bottom: 8px; }
</style>
